import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Assuming custom styles are here

const CityDetails = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [cityDetails, setCityDetails] = useState([
    { city: "Colombo", status: "Active", id: 1 },
    { city: "Kandy", status: "Inactive", id: 2 },
    { city: "Galle", status: "Active", id: 3 },
    { city: "Jaffna", status: "Inactive", id: 4 },
    { city: "Negombo", status: "Active", id: 5 },
  ]);

  const [formData, setFormData] = useState({
    city: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [cityDetails]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedCity) {
      setCityDetails(
        cityDetails.map((city) =>
          city.id === selectedCity.id ? { ...formData, id: city.id } : city
        )
      );
    } else {
      setCityDetails([
        ...cityDetails,
        { ...formData, id: cityDetails.length ? cityDetails[cityDetails.length - 1].id + 1 : 1 },
      ]);
    }
    setShowForm(false);
    setFormData({ city: "", status: "Active" });
    setSelectedCity(null);
  };

  const handleEdit = (city) => {
    setSelectedCity(city);
    setFormData({
      city: city.city,
      status: city.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedCity(null);
    setFormData({ city: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="city-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left-side Form Panel */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "320px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedCity ? "Edit City" : "Add City"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>City:</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Table Section */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>City Details</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add City
            </button>
          </div>
          <div className="card-body">
            <table ref={tableRef} className="table table-bordered display" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>City</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {cityDetails.map((city) => (
                  <tr key={city.id}>
                    <td>{city.city}</td>
                    <td>
                      <span className={`badge ${city.status === "Active" ? "bg-success" : "bg-danger"}`}>
                        {city.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(city)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityDetails;
